import React from 'react';
import { graphql } from 'react-apollo';
import { GET } from "../../../queries/site";
import MenuItem from '@material-ui/core/MenuItem';
import { InputLabel, Select, Input } from '@material-ui/core';

const sitesFunc = ({ form: { form }, sitesData:{ sitesData }, onChange: sitesChange, data: { sites, loading, error }}) => {
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;
  if(sites)
  sites.sort(function(a, b){
    if(a.name < b.name) { return -1; }
    if(a.name > b.name) { return 1; }
    return 0;
  })
  const handleChange = (e) => {
      if(sitesChange){
        sitesChange(e.target.value);
      }
  }
  return (
    <>
    {
      
    form.getFieldDecorator('sites',
           {
            initialValue: (sitesData || '')
          })(<>
            <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Sites</InputLabel>
            <Select
            labelId="demo-mutiple-name-label"
            id="sites-lookup-id"
            multiple
            value={sitesData}
            onChange={handleChange}
            input={<Input />}
            style={{ width : '100%' }}
            >
            {            
            sites.map(item => (
                <MenuItem key={item.id} value={item.id}>
                {item.name}
                </MenuItem>
            ))}
            </Select>
            </>
          )}
    </>
        
  );
}
export const SitesLookup = graphql(GET)((sitesFunc));